import { render, staticRenderFns } from "./StylingSection.vue?vue&type=template&id=33345c90&scoped=true"
import script from "./StylingSection.vue?vue&type=script&lang=js"
export * from "./StylingSection.vue?vue&type=script&lang=js"
import style0 from "./StylingSection.vue?vue&type=style&index=0&id=33345c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33345c90",
  null
  
)

export default component.exports